// @flow

export const SERVICES = Object.freeze({
  HISTORY: 'historyService',
  BOOTSTRAP: 'bootstrap',
  UPDATER: 'updater',
})
